import { isToolbarSeoActive } from './ToolbarStore';

export const updateToolbarSeo = (value) => isToolbarSeoActive.update((oldValue) => value);
